import type { Camera, Scene, WebGLRenderer, WebGLRenderTarget } from '@seddi/three';
import { EffectComposer } from '@seddi/three/addons/postprocessing/EffectComposer.js';
import { OutputPass } from '@seddi/three/addons/postprocessing/OutputPass.js';
import { MsaaRenderPass } from '../three/postprocessing/msaaRenderPass';

export class DefaultRenderingPipeline {
  readonly composer: EffectComposer;
  private readonly outputPass: OutputPass;
  private readonly renderPass: MsaaRenderPass;

  constructor(
    renderer: WebGLRenderer,
    scene: Scene,
    camera: Camera,
    renderTarget?: WebGLRenderTarget,
  ) {
    const composer = new EffectComposer(renderer, renderTarget);
    this.composer = composer;
    const renderPass = new MsaaRenderPass(scene, camera);
    this.renderPass = renderPass;
    const outputPass = new OutputPass();
    this.outputPass = outputPass;
    composer.addPass(renderPass);
    composer.addPass(outputPass);
  }

  dispose() {
    this.composer.dispose();
    this.renderPass.dispose();
    this.outputPass.dispose();
  }

  setCamera(camera: Camera) {
    this.renderPass.camera = camera;
  }

  /**
   * Resizes the internal read and write buffers as well as all passes.
   * @param width - Width in content box size units.
   * @param height - Height in content box size units.
   */
  setSize(width: number, height: number) {
    this.composer.setSize(width, height);
  }

  render(deltaTime?: number) {
    this.composer.render(deltaTime);
  }
}
